module.exports = __webpack_public_path__ + "img/symbol_17.573aabe7.png";